/**
 * Convert a base64 data URL — e.g. a webcam screenshot (`canvas.toDataURL`)
 * @throws if the string is not a base64-encoded data URL.
 */
export function dataUrlToFile(dataUrl: string, fileName: string): File {
  const match = /^data:(.+?);base64,([\s\S]*)$/.exec(dataUrl);
  if (!match) {
    throw new Error("Expected a base64-encoded data URL.");
  }

  const [, mimeType, base64] = match;
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], fileName, { type: mimeType });
}
